<template>
    <v-autocomplete
            :label="(label)? label : 'Búsqueda de proveedor'"
            :items="items"
            :value="value"
            :multiple="multiple"
            :error-messages="errores.collect('item')"
            :search-input.sync="search"
            :loading="loading"
            :cache-items="multiple"
            return-object
            item-text="A2_NOME"
            item-value="A2_COD"
            v-validate="validate"
            data-vv-name="item"
            required
            clearable
            hide-no-data
            @input="actualizaValor($event)"
            @blur="$emit('blur')"
            @change="change($event)"
    >
    </v-autocomplete>
</template>
<script>
    import mixinProveedores from '../mixins/micro/proveedores'

    export default {
        inject: ['$validator'],
        name: 'micro-proveedor-select',
        props: ['label', 'value', 'tipo', 'preset', 'validate', 'empresa', 'multiple'],
        mixins: [mixinProveedores],
        data() {
            return {
                search: '',
                loading: false,
                listado: []
            }
        },
        computed: {
            items() {
                if (this.listado && Object.keys(this.listado).length !== 0) {
                    return this.listado;
                } else {
                    return (this.preset) ? [this.preset] : [];
                }
            }
        },
        watch: {
            search(val) {
                if (!val) {
                    return false;
                }
                let valor = (this.value && typeof this.value === 'object' && this.value.A2_NOME) ? this.value.A2_NOME : '';
                val && val !== valor && this.query(val)
            }
        },
        methods: {
            query(val) {
                this.loading = true;
                this.microProveedorBuscar({
                    empresa: this.empresa,
                    q: val
                }, r => {
                    this.listado = r;
                    this.loading = false;
                }, err => {
                    console.log(err);
                    this.loading = false;
                })
            },
            actualizaValor(valor) {
                if (!valor) {
                    return false;
                }
                this.$emit('update:id', valor.id);
                this.$emit('input', valor);
            },
            change(e) {
                this.$emit('change', e);
            }
        }
    }
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/MicroProveedorSelect.vue